import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "../PRmanagerLayout/PRmanager.css";
import "./SubAccount.css";
import { useEffect, useState } from "react";
import Instance from "../../Utils/Axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../Utils/index";
import useFormValidation from "../../Hooks/useformValidation";
import { SubAccountSchema } from "../../Utils/validationSchema";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const SubAccountEdit = () => {
  const { subID } = useParams();
  const navigate = useNavigate();
  const [countryList, setCountryList] = useState([]);
  const [companyData, setCompanyData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useFormValidation(SubAccountSchema);

  const watchCountry = watch("country");

  useEffect(() => {
    setLoading(true)
    const fetchCompanyDetails = async () => {
      try {
        const token = localStorage.getItem("tokenId");
        const response = await Instance.post("/user/usercompany/details", {
          // tokenId: token,
          companyId: subID,
        });
        const data = response.data.message;
        setCompanyData(data);

        // Set form values
        Object.keys(data).forEach((key) => {
          setValue(key, data[key]);
        });

        setError("");
      } catch (error) {
        setError("Failed to fetch company details");
        console.error("Failed to fetch company detail", error);
      } finally {
        setLoading(false)
      }
    };

    fetchCompanyDetails();
  }, [subID, setValue]);

  const fetchCountryList = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/common/countryList", {
      // tokenId: token,
      status: "ACTIVE",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          const filteredCountries = response.data.message.filter(
            (country) => country.countryName.trim() !== ""
          );
          setCountryList(filteredCountries);
          setError("");
        } else {
          setError("Failed to fetch countries list");
          console.error(
            "Error fetching countries list:",
            response.data.resMessage
          );
        }
      })
      .catch((error) => {
        setError("Failed to fetch countries list");
        console.error("Error fetching countries list:", error);
      });
  };

  useEffect(() => {
    fetchCountryList();
  }, []);

  useEffect(() => {
    if (countryList.length > 0 && companyData && !companyData.country) {
      const india = countryList.find(
        (c) => c.countryCode === "IN"
      );

      if (india) {
        setValue("isdCode", india.isdCode);
        setValue("country", india.countryCode);
      }
    }
  }, [countryList, companyData, setValue]);

  const onSubmit = async (formData) => {
    try {
      const token = localStorage.getItem("tokenId");
      const response = await Instance.post(`/user/usercompany/update`, {
        // tokenId: token,
        companyId: subID,
        ...formData,
      });
      if (response.data.resCode === "200") {
        showToast("Updated Successfully!", "success", "success");
        setTimeout(() => {
          navigate("/customer/sub-account");
        }, 1000);
      } else {
        setError(response.data.resMessage);
      }
    } catch (error) {
      setError("Error updating the company details");
      console.error("Error updating the company details:", error);
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCancel = () => {
    navigate("/customer/sub-account");
  };

  return (
    <div className="sub_account_add_wrapper">
      <div className={`pr_secondary_nav`}>
        <Link to="/customer/sub-account">
          <button className="sub_back_btn mt-3" type="button">
            <img
              className={"sub_back_img mb-0"}
              src="/build/img/Icons/Chevron.svg"
              alt="Back"
              width={20}
              height={20}
            />
            Back
          </button>
        </Link>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className="pr_form_preview">
          <h4 className="sub_form_head mb-4">Edit company profile ID: {subID}</h4>

          <Row>
            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                placeholder="Enter Company Name"
                {...register("name")}
              />
              {errors.name && <p className="text-danger">{errors.name.message}</p>}
            </Col>

            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Contact Person Name</Form.Label>
              <Form.Control
                placeholder="Enter Contact Person Name"
                {...register("contactPerson")}
              />
              {errors.contactPerson && <p className="text-danger">{errors.contactPerson.message}</p>}
            </Col>
          </Row>

          <Row>
            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Company Website</Form.Label>
              <Form.Control
                placeholder="Enter Website"
                {...register("website")}
              />
              {errors.website && <p className="text-danger">{errors.website.message}</p>}
            </Col>

            {/* <Col className="custom_col_sub_account mb-4">
              <Form.Label>Created By</Form.Label>
              <Form.Control
                placeholder="Enter Created By"
                {...register("createdBy")}
              />
              {errors.createdBy && <p className="text-danger">{errors.createdBy.message}</p>}
            </Col> */}
          </Row>

          <Row>
            <Col lg={6} className="custom_col_sub_account mb-4">
              <Form.Label>Status</Form.Label>
              <Form.Select {...register("status")}>
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
              </Form.Select>
              {errors.status && <p className="text-danger">{errors.status.message}</p>}
            </Col>
            <Col lg={6} className="custom_col_sub_account mb-4">
              <Form.Label>Company Address</Form.Label>
              <Form.Control
                placeholder="Enter Address"
                {...register("address")}
              />
              {errors.address && <p className="text-danger">{errors.address.message}</p>}
            </Col>
          </Row>

          <Row>
            <Col xs="6" className="custom_col_sub_account mb-4">
              <Form.Label>Country</Form.Label>
              <Controller
                name="country"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={countryList.map((country) => ({
                      value: country.countryCode,
                      label: country.countryName,
                      isdCode: country.isdCode
                    }))}
                    formatOptionLabel={({ label, value }) => (
                      <div className="d-flex align-items-center">
                        <img
                          src={`https://flagcdn.com/w20/${value.toLowerCase()}.png`}
                          alt=""
                          className="me-2"
                          style={{ width: "20px", height: "auto" }}
                        />
                        <span>{label} ({value})</span>
                      </div>
                    )}
                    placeholder="Select Country"
                    isSearchable
                    classNamePrefix="react-select"
                    value={
                      field.value
                        ? {
                          value: field.value,
                          label: countryList.find(c => c.countryCode === field.value)?.countryName || field.value,
                        }
                        : null
                    }
                    onChange={(val) => {
                      field.onChange(val.value);
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderRadius: "8px",
                        borderColor: state.isFocused ? "#585edb" : "#ced4da",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: "#585edb",
                        },
                        minHeight: "45px",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                          ? "#585edb"
                          : state.isFocused
                            ? "#f1f2fd"
                            : "transparent",
                        color: state.isSelected ? "white" : "#091e42",
                        "&:active": {
                          backgroundColor: "#585edb",
                        },
                      }),
                    }}
                  />
                )}
              />
              {errors.country && <p className="text-danger">{errors.country.message}</p>}
            </Col>

            <Col xs="3" className="custom_col_sub_account mb-4">
              <Form.Label>City</Form.Label>
              <Form.Control
                placeholder="Enter City"
                {...register("city")}
              />
              {errors.city && <p className="text-danger">{errors.city.message}</p>}
            </Col>

            <Col xs="3" className="custom_col_sub_account mb-4">
              <Form.Label>State</Form.Label>
              <Form.Control
                placeholder="Enter State"
                {...register("state")}
              />
              {errors.state && <p className="text-danger">{errors.state.message}</p>}
            </Col>
          </Row>

          <Row>
            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Email</Form.Label>
              <Form.Control
                placeholder="Enter Email"
                type="email"
                {...register("email")}
              />
              {errors.email && <p className="text-danger">{errors.email.message}</p>}
            </Col>

            <Col className="custom_col_sub_account mb-4">
              <Form.Label>Phone Number</Form.Label>
              <div className="phone_input_wrapper">
                <div className="isd_code_dropdown">
                  <Controller
                    name="isdCode"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={countryList.map((country) => ({
                          value: country.isdCode,
                          label: country.isdCode,
                          countryCode: country.countryCode,
                        }))}
                        formatOptionLabel={({ label, countryCode }) => (
                          <div className="d-flex align-items-center">
                            <img
                              src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
                              alt=""
                              className="me-2"
                              style={{ width: "15px", height: "auto" }}
                            />
                            <span>{label}</span>
                          </div>
                        )}
                        placeholder="+91"
                        isSearchable
                        classNamePrefix="react-isd-select"
                        menuPortalTarget={document.body}
                        value={
                          field.value
                            ? (() => {
                              const cleanField = String(field.value).replace("+", "");
                              const selectedCountry = countryList.find(
                                (c) => String(c.isdCode || "").replace("+", "") === cleanField
                              );
                              return selectedCountry
                                ? {
                                  value: selectedCountry.isdCode,
                                  label: selectedCountry.isdCode,
                                  countryCode: selectedCountry.countryCode,
                                }
                                : null;
                            })()
                            : null
                        }
                        onChange={(val) => {
                          field.onChange(val.value);

                          const cleanVal = String(val.value).replace("+", "");
                          const selectedCountry = countryList.find(
                            (c) => String(c.isdCode || "").replace("+", "") === cleanVal
                          );

                          if (selectedCountry) {
                            setValue("isdCode", selectedCountry.isdCode);
                          }

                          setValue("mobile", "");
                        }}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: "8px 0 0 8px",
                            borderColor: "transparent",
                            boxShadow: "none",
                            "&:hover": {
                              borderColor: "transparent",
                            },
                            minHeight: "48px",
                            borderRight: "none",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                            width: "150px",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#585edb"
                              : state.isFocused
                                ? "#f1f2fd"
                                : "transparent",
                            color: state.isSelected ? "white" : "#091e42",
                            "&:active": {
                              backgroundColor: "#585edb",
                            },
                          }),
                        }}
                      />
                    )}
                  />
                </div>
                <div className="phone_number_input">
                  <Form.Control
                    placeholder="Enter Phone Number"
                    type="text"
                    {...register("mobile")}
                  />
                </div>
              </div>
              {(errors.mobile || errors.isdCode) && (
                <p className="text-danger">
                  {errors.isdCode?.message || errors.mobile?.message}
                </p>
              )}
            </Col>
          </Row>
          {error && <p className="text-danger">{error}</p>}
        </div>

        <div className="sub_account_buttons">
          <button
            className="sub_cancel_btn mb-4"
            type="button"
            onClick={handleShowModal}
          >
            Cancel
          </button>
          <button className="sub_save_btn mb-4" type="submit">
            Save Changes
          </button>
        </div>
      </Form>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        className="cancel_modal"
      >
        <Modal.Body>
          <div>
            <h5 className="submit_modal_head">Cancel</h5>
            <p className="submit_modal_content">
              Are you sure you want to cancel? Any unsaved changes will be lost.
            </p>
          </div>
          <div className="pr_modal_btn">
            <Button
              className="submit_cancel_btn"
              onClick={handleCloseModal}
            >
              No
            </Button>
            <Button
              className="submit_save_btn"
              onClick={handleCancel}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubAccountEdit;

